export default {"src":"/_next/static/media/caret-left-solid.e006335e.svg","height":512,"width":256};